<ng-container dynamic-field
              [field]="{
                        type: 'select-search',
                        label: field?.label,
                        inputType: 'text',
                        name: field.name,
                        hint: field?.hint,
                        required: field?.required,
                        options: monthListObject,
                        multiple: false,
                        validations: field.validations}"
              [group]="group">
</ng-container>
